var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWSf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1292_46925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6665 25.6875C23.3235 25.6875 24.6665 24.7925 24.6665 23.6875C24.6665 22.5825 23.3235 21.6875 21.6665 21.6875C20.0095 21.6875 18.6665 20.7925 18.6665 19.6875C18.6665 18.5825 20.0095 17.6875 21.6665 17.6875M21.6665 25.6875V17.6875M21.6665 25.6875C20.5565 25.6875 19.5865 25.2855 19.0675 24.6875M21.6665 25.6875V26.6875M21.6665 17.6875V16.6875M21.6665 17.6875C22.7765 17.6875 23.7465 18.0895 24.2655 18.6875M12.6665 21.6875C12.6665 20.5056 12.8993 19.3353 13.3516 18.2433C13.8039 17.1514 14.4668 16.1593 15.3025 15.3235C16.1383 14.4878 17.1304 13.8249 18.2224 13.3726C19.3143 12.9203 20.4846 12.6875 21.6665 12.6875C22.8484 12.6875 24.0187 12.9203 25.1107 13.3726C26.2026 13.8249 27.1947 14.4878 28.0305 15.3235C28.8662 16.1593 29.5291 17.1514 29.9814 18.2433C30.4337 19.3353 30.6665 20.5056 30.6665 21.6875C30.6665 24.0744 29.7183 26.3636 28.0305 28.0515C26.3426 29.7393 24.0535 30.6875 21.6665 30.6875C19.2796 30.6875 16.9904 29.7393 15.3025 28.0515C13.6147 26.3636 12.6665 24.0744 12.6665 21.6875Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6665 13.6403C25.2079 12.7532 24.606 11.952 23.8915 11.2675C22.2749 9.719 20.0818 8.76755 17.6665 8.76755C12.6959 8.76755 8.6665 12.797 8.6665 17.7675C8.6665 20.1829 9.61795 22.376 11.1665 23.9925C11.8835 24.741 12.7286 25.3659 13.6665 25.832",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00016 7.33398V30.0006M4.00016 30.0006H2.3335M4.00016 30.0006H10.6668",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 8.66732L16.0002 1.33398L30.6668 8.66732",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1292_46925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWSf);
export default __webpack_public_path__ + "static/media/wSF.c7c68395c80301a39a47806e03d3af1e.svg";
export { ForwardRef as ReactComponent };